/**
 * WARNING:
 * DO NOT CHANGE THE VALUES OF THIS ENUM WITHOUT HAVING AN APPROPRIATE MIGRATION PLAN IN PLACE.
 * THE VALUES CORRESPONDING TO QUEUE NAMES AND CHANGING THEM WILL BREAK THE SYSTEM RESULTING
 * IN STALLED JOBS IN THE QUEUE.
 */
export var JobTopicNameEnum;
(function (JobTopicNameEnum) {
    JobTopicNameEnum["ACTIVE_JOBS_METRIC"] = "metric-active-jobs";
    JobTopicNameEnum["INBOUND_PARSE_MAIL"] = "inbound-parse-mail";
    JobTopicNameEnum["STANDARD"] = "standard";
    JobTopicNameEnum["WEB_SOCKETS"] = "ws_socket_queue";
    JobTopicNameEnum["WORKFLOW"] = "trigger-handler";
    JobTopicNameEnum["PROCESS_SUBSCRIBER"] = "process-subscriber";
})(JobTopicNameEnum || (JobTopicNameEnum = {}));
/**
 * Which queue backend a deployment produces to, and whether it still runs a
 * BullMQ worker.
 *
 * `SQS_BULLMQ` is the migration state: producers write to SQS, BullMQ absorbs
 * sends SQS rejects, and the BullMQ worker keeps running so jobs delayed before
 * the switch still fire. Moving to `SQS` retires BullMQ entirely, so it is only
 * safe once no delayed BullMQ jobs remain — deferral is capped at 180 days, and
 * a job left in the delayed set when BullMQ stops is never delivered.
 */
export var QueueBackend;
(function (QueueBackend) {
    QueueBackend["BULLMQ"] = "bullmq";
    QueueBackend["SQS_BULLMQ"] = "sqs_bullmq";
    QueueBackend["SQS"] = "sqs";
})(QueueBackend || (QueueBackend = {}));
export var ObservabilityBackgroundTransactionEnum;
(function (ObservabilityBackgroundTransactionEnum) {
    ObservabilityBackgroundTransactionEnum["JOB_PROCESSING_QUEUE"] = "job-processing-queue";
    ObservabilityBackgroundTransactionEnum["SUBSCRIBER_PROCESSING_QUEUE"] = "subscriber-processing-queue";
    ObservabilityBackgroundTransactionEnum["TRIGGER_HANDLER_QUEUE"] = "trigger-handler-queue";
    ObservabilityBackgroundTransactionEnum["WS_SOCKET_QUEUE"] = "ws_socket_queue";
    ObservabilityBackgroundTransactionEnum["WS_SOCKET_SOCKET_CONNECTION"] = "ws_socket_handle_connection";
    ObservabilityBackgroundTransactionEnum["WS_SOCKET_HANDLE_DISCONNECT"] = "ws_socket_handle_disconnect";
    ObservabilityBackgroundTransactionEnum["CRON_JOB_QUEUE"] = "cron-job-queue";
    ObservabilityBackgroundTransactionEnum["CLICKHOUSE_BATCH_FLUSH"] = "clickhouse-batch-flush";
    ObservabilityBackgroundTransactionEnum["INBOUND_MAIL_PROCESSING"] = "inbound-mail-processing";
})(ObservabilityBackgroundTransactionEnum || (ObservabilityBackgroundTransactionEnum = {}));
export var JobCronNameEnum;
(function (JobCronNameEnum) {
    JobCronNameEnum["SEND_CRON_METRICS"] = "send-cron-metrics";
    JobCronNameEnum["CREATE_BILLING_USAGE_RECORDS"] = "create-billing-usage-records";
    JobCronNameEnum["SEND_USAGE_REPORT"] = "send-usage-report";
})(JobCronNameEnum || (JobCronNameEnum = {}));
//# sourceMappingURL=job-queue.js.map